/**
 * Product positioning for scratch_card — merchant-facing copy (catalog, campaign).
 * Fast reveal, lower setup than a segmented wheel; good for impulse and simple promos.
 */
export const SCRATCH_CARD_FAMILY_DESCRIPTION =
  "Fast scratch-to-reveal promos — shoppers uncover one prize in a single gesture. " +
  "Quicker to set up than a full wheel: ideal when you want a tactile instant-win moment " +
  "without segment math or spin mechanics.";

/** Short line for variant modal / tooltips */
export const SCRATCH_VARIANT_HELP =
  "Scratch cards use CTA text and a surface finish (foil, silver, gold) on the storefront. " +
  "Rewards still come from the reward policy you attach to this variant.";
